import { render, staticRenderFns } from "./Adjective.vue?vue&type=template&id=4c28846c&scoped=true&"
import script from "./Adjective.vue?vue&type=script&lang=js&"
export * from "./Adjective.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c28846c",
  null
  
)

export default component.exports